import React from 'react';
import './HowToEnroll.css';

const HowToEnroll: React.FC = () => {
  const steps = [
    { number: '01', title: 'Visit Our School', description: 'Tour our facilities and meet our team' },
    { number: '02', title: 'Meet Our Teachers', description: 'Get to know our experienced educators' },
    { number: '03', title: 'Submit Application', description: 'Fill out the enrollment form' },
    { number: '04', title: 'Start Learning', description: 'Begin the exciting journey' }
  ];

  return (
    <section className="how-to-enroll">
      <div className="container">
        <h2 className="section-title">How to Enroll Your Child at Our School</h2>
        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              {index < steps.length - 1 && <div className="step-arrow">→</div>}
            </div>
          ))}
        </div>
        <button className="enroll-button">Get Started</button>
      </div>
    </section>
  );
};

export default HowToEnroll;
